import {useQuery} from '@tanstack/react-query'

import {listActiveRentals} from './api'
import {activeRentalKeys} from './query-keys'

export function useActiveRentals(filters: {mine: boolean; yardId: string | null}) {
    return useQuery({
        queryKey: activeRentalKeys.list(filters),
        queryFn: () => listActiveRentals(filters),
        refetchOnWindowFocus: 'always',
    })
}
